import React, { Fragment } from 'react'
import EventDescription from './Components/EventDescription'
import Breadcroumb from '../../components/Breadcroumb/Breadcroumb'
import withScrollHOC from '../../HOC/ScrollHOC'
import WorkGallery from "./Components/WorkGallery";
import SimilerEvents from "./Components/SimilerEvents";

function EventDetails3() {
    return (
        <Fragment>
            <Breadcroumb name="Event Details"/>
            <div className="event-area">
                <div className="container">
                    <div className="row">
                        <EventDescription/>
                        <SimilerEvents/>
                    </div>
                </div>
            </div>
            <WorkGallery/>
        </Fragment>
    )
}

export default withScrollHOC(EventDetails3)
